module.exports = __webpack_public_path__ + "static/media/video_poster.879bc189.png";